export const openModal = () => {
    document.body.style.overflowY = 'hidden';
    document.getElementsByClassName("overlay")[0].style.visibility = "unset"
    document.getElementsByClassName("overlay")[0].style.opacity = 1
    document.getElementById("navigationBar").style.display = "none"
}